import { useEffect, useState } from 'react';
import { Alert } from 'antd';
import { WifiOutlined } from '@ant-design/icons';

/**
 * Shows a sticky banner at the top of the page when the browser loses
 * network connectivity. Disappears automatically when the connection returns.
 */
const OfflineBanner: React.FC = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const goOnline  = () => setIsOnline(true);
    const goOffline = () => setIsOnline(false);

    window.addEventListener('online',  goOnline);
    window.addEventListener('offline', goOffline);
    return () => {
      window.removeEventListener('online',  goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  if (isOnline) return null;

  return (
    <Alert
      icon={<WifiOutlined />}
      showIcon
      type="warning"
      message="You're offline"
      description="Some features may not work until your connection is restored."
      banner
      style={{
        position: 'sticky',
        top: 56,           // sits just below the 56px app header
        zIndex: 999,
        borderRadius: 0,
        borderLeft: 'none',
        borderRight: 'none',
      }}
    />
  );
};

export default OfflineBanner;
